import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { CharLength } from '../../../../modules/directives/char-length.directive';

@Component({
  selector: 'app-bank-details-step',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CharLength],
  templateUrl: './bank-details-step.component.html',
})
export class BankDetailsStepComponent {
  @Input({ required: true }) group!: FormGroup;
  @Input() banks: Array<{ code: string; name: string }> = [];
  @Input() busyVerify = false;

  open = false;
  term = '';

  constructor(private readonly elRef: ElementRef<HTMLElement>) {}

  hasError(controlName: string): boolean {
    const control = this.group?.get(controlName);
    return !!control && control.invalid && (control.touched || control.dirty);
  }

  get selectedBankName(): string {
    const code = String(this.group?.get('bank')?.value ?? '').trim();
    return this.banks.find((b) => String(b.code).trim() === code)?.name ?? '';
  }

  get filteredBanks(): Array<{ code: string; name: string }> {
    const q = this.term.trim().toLowerCase();
    if (!q) return this.banks;
    return this.banks.filter((b) => String(b.name ?? '').toLowerCase().includes(q));
  }

  toggle(): void {
    this.open ? this.close() : this.openDropdown();
  }

  openDropdown(): void {
    this.open = true;
  }

  close(): void {
    this.open = false;
    this.term = '';
  }

  selectBank(bank: { code: string; name: string }): void {
    this.group?.get('bank')?.setValue(String(bank.code ?? '').trim());
    this.group?.get('bank')?.markAsDirty();
    this.close();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(evt: MouseEvent): void {
    if (!this.open) return;
    const target = evt.target as Node | null;
    if (!target) return;
    if (!this.elRef.nativeElement.contains(target)) {
      this.close();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (!this.open) return;
    this.close();
  }
}
